
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jwLDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3ae64d7a6ef011e$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6UbAk = parcelRequire("6UbAk");

var $dC2mi = parcelRequire("dC2mi");

var $4Kt0R = parcelRequire("4Kt0R");

var $j154p = parcelRequire("j154p");

var $eslhe = parcelRequire("eslhe");

var $7Odw0 = parcelRequire("7Odw0");

var $eSXdz = parcelRequire("eSXdz");

var $bpQLU = parcelRequire("bpQLU");


var $kFDmj = parcelRequire("kFDmj");

var $ajncg = parcelRequire("ajncg");

var $1OTgk = parcelRequire("1OTgk");

var $9Oo0T = parcelRequire("9Oo0T");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");

var $cvA2R = parcelRequire("cvA2R");

var $k6ufm = parcelRequire("k6ufm");

var $7UpgX = parcelRequire("7UpgX");

var $iSqcu = parcelRequire("iSqcu");

var $9a8hO = parcelRequire("9a8hO");
const $a3ae64d7a6ef011e$var$create = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create",
    id: "atlassian-navigation.create.create"
});
const $a3ae64d7a6ef011e$var$createButtonAriaLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create issue",
    id: "atlassian-navigation.create.create-button-aria-label"
});
const $a3ae64d7a6ef011e$var$createButtonAriaLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create",
    id: "atlassian-navigation.create.create-button-aria-label-issue-term-refresh"
});
const $a3ae64d7a6ef011e$var$noop = ()=>undefined;
const $a3ae64d7a6ef011e$var$Create = ({ AkCreate: AkCreate = (0, $j154p.Create), NudgeTooltip: NudgeTooltip = (0, $dC2mi.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $bpQLU.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $7UpgX.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $eSXdz.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $ajncg.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $9Oo0T.useTriggerIssueCreateModal)();
    (0, $kFDmj.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $4Kt0R.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $euxye.useRef)(false);
    const isAnonymous = (0, $cvA2R.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $7Odw0.isSupportedUserAgent)();
    // TODO: delete this code for clean up issue-create-stop-using-gicoptinstatusresources
    if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) {
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $k6ufm.useResource)((0, $6UbAk.gicOptInStatusResources));
        // oxlint-disable-next-line react-hooks/rules-of-hooks
        (0, $euxye.useLayoutEffect)(()=>{
            if (isAnonymous && !gicOptInStateOverridden.current) {
                update(()=>({
                        gicOptInStatus: {
                            isEnabled: true
                        }
                    }));
                gicOptInStateOverridden.current = true;
            }
        }, [
            isAnonymous,
            update
        ]);
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $euxye.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) {
            if ((0, $i860n.fg)('issue-create-stop-using-gicoptinstatusresources')) {
                (0, $iSqcu.GlobalIssueCreateFromTopNav).abort({
                    force: true
                });
                (0, $iSqcu.GlobalIssueCreateFromTopNav).start();
                (0, $iSqcu.GlobalIssueCreateFromTopNav).addMetadata({
                    inputDelay: Math.round(performance.now() - e.timeStamp)
                });
                const nextState = {
                    disableCreationSuccessFlag: (0, $9a8hO.shouldDisableGICFlagCreation)(),
                    triggerPointKey: (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
                    ...isMobileExperienceEnabled ? {
                        displayMinimizableButtons: false,
                        displayCreateAnotherIssueToggle: false,
                        triggerPointKey: (0, $1OTgk.MOBILE_GLOBAL_CREATE_BUTTON)
                    } : {}
                };
                openIssueCreateModal(nextState);
            } else if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $iSqcu.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $iSqcu.GlobalIssueCreateFromTopNav).start();
                    (0, $iSqcu.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $9a8hO.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $1OTgk.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $42000e90ec1a6081$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $6CfY5.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $42000e90ec1a6081$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage($a3ae64d7a6ef011e$var$create),
        testId: testId,
        label: formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $a3ae64d7a6ef011e$var$createButtonAriaLabelIssueTermRefresh : $a3ae64d7a6ef011e$var$createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(AkCreate, {
        onClick: $a3ae64d7a6ef011e$var$noop,
        text: formatMessage($a3ae64d7a6ef011e$var$create),
        testId: testId,
        label: formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $a3ae64d7a6ef011e$var$createButtonAriaLabelIssueTermRefresh : $a3ae64d7a6ef011e$var$createButtonAriaLabel)
    });
};
$a3ae64d7a6ef011e$var$Create.displayName = "Create";
const $a3ae64d7a6ef011e$var$CreateWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eslhe.TopLevelErrorBoundary), {
        id: (0, $4Kt0R.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a3ae64d7a6ef011e$var$Create, props));
$a3ae64d7a6ef011e$var$CreateWithErrorBoundary.displayName = "CreateWithErrorBoundary";
var $a3ae64d7a6ef011e$export$2e2bcd8739ae039 = $a3ae64d7a6ef011e$var$CreateWithErrorBoundary;

});
parcelRegister("dC2mi", function(module, exports) {
$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $a9d6728219737a6c$export$fc0840474cb1fce9);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");


var $4dhaE = parcelRequire("4dhaE");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $78ZxQ = parcelRequire("78ZxQ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a9d6728219737a6c$var$NavigationCreateIssueButtonLazy = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("eiMVP")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/NavigationCreateIssueButtonWrapperNudge.tsx"
});
const $a9d6728219737a6c$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $78ZxQ.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4dhaE.OnboardingNudgeErrorBoundary), {
        id: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a9d6728219737a6c$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $99cb2e6a234d7a1f$export$aba87e019f5ccb8d)
    }, children)));
};
$a9d6728219737a6c$export$fc0840474cb1fce9.displayName = "NavigationCreateIssueButtonWrapperNudgeAsync";

});
/* eslint-disable jira/filename-case */ // Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $99cb2e6a234d7a1f$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $99cb2e6a234d7a1f$export$e3884212029f7bef = 'should-show-welcome-modal';
const $99cb2e6a234d7a1f$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $99cb2e6a234d7a1f$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $99cb2e6a234d7a1f$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $99cb2e6a234d7a1f$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $99cb2e6a234d7a1f$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $99cb2e6a234d7a1f$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $99cb2e6a234d7a1f$export$6e69f8dc03075ef8 = 'team-type';
const $99cb2e6a234d7a1f$export$c06666264cd35603 = 'team-type-shorthand';
const $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $99cb2e6a234d7a1f$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $99cb2e6a234d7a1f$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $99cb2e6a234d7a1f$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $99cb2e6a234d7a1f$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $99cb2e6a234d7a1f$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $99cb2e6a234d7a1f$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $99cb2e6a234d7a1f$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $99cb2e6a234d7a1f$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $99cb2e6a234d7a1f$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $99cb2e6a234d7a1f$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $99cb2e6a234d7a1f$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $99cb2e6a234d7a1f$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99cb2e6a234d7a1f$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $99cb2e6a234d7a1f$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $99cb2e6a234d7a1f$export$468488291ccd988 = 'timelineAddItemNudge';
const $99cb2e6a234d7a1f$export$7a33548109ac931d = 'createFormNudge';
const $99cb2e6a234d7a1f$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $99cb2e6a234d7a1f$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $99cb2e6a234d7a1f$export$594d3436316492be = 'summaryViewNudge';
const $99cb2e6a234d7a1f$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $99cb2e6a234d7a1f$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99cb2e6a234d7a1f$export$699265ec8ad9a740 = 'Software Development';
const $99cb2e6a234d7a1f$export$e07d1fa2da8ed874 = 'Customer Service';
const $99cb2e6a234d7a1f$export$76dcec3f438d9e56 = 'IT Support';
const $99cb2e6a234d7a1f$export$9a574c301f67ba30 = 'Human Resources';
const $99cb2e6a234d7a1f$export$363ec144a94029c8 = 'Finance';
const $99cb2e6a234d7a1f$export$df0fb32d68ae1e78 = 'Legal';
const $99cb2e6a234d7a1f$export$d9c0e3e59442fb4 = 'Marketing';
const $99cb2e6a234d7a1f$export$27dbc7d7ce66e6e3 = 'Operations';
const $99cb2e6a234d7a1f$export$a5dce388adf922bd = 'Sales';
const $99cb2e6a234d7a1f$export$e1473b31a257caff = 'Data Science';
const $99cb2e6a234d7a1f$export$85657457db93c2c2 = 'Product Management';
const $99cb2e6a234d7a1f$export$c0c2d1dfaeba89dd = 'Project Management';
const $99cb2e6a234d7a1f$export$2e6a7ad3ab9c82a3 = 'Design';
const $99cb2e6a234d7a1f$export$7b60378c3b4372e9 = 'Other or Personal';
const $99cb2e6a234d7a1f$export$572242e58bd07594 = 'CS';
const $99cb2e6a234d7a1f$export$d7de553940261eba = 'ITS';
const $99cb2e6a234d7a1f$export$4c29d0d04c15e55d = 'HR';
const $99cb2e6a234d7a1f$export$3950f7f841bf94b6 = 'FNC';
const $99cb2e6a234d7a1f$export$881249b988b6030f = 'LGL';
const $99cb2e6a234d7a1f$export$e4824f74b9879164 = 'MKT';
const $99cb2e6a234d7a1f$export$4f3cb0844009af52 = 'OPS';
const $99cb2e6a234d7a1f$export$1a65d50c4a641bb4 = 'SAL';
const $99cb2e6a234d7a1f$export$9ee64e8fbd8b03a2 = 'DS';
const $99cb2e6a234d7a1f$export$b8b1ac856ba1434b = 'DEV';
const $99cb2e6a234d7a1f$export$4f54a09a24fd1d74 = 'PDM';
const $99cb2e6a234d7a1f$export$79685802e8ff1098 = 'PJM';
const $99cb2e6a234d7a1f$export$e5c438b7501b5a24 = 'DES';
const $99cb2e6a234d7a1f$export$cbc0e551d91a692d = 'OTR';

parcelRegister("4dhaE", function(module, exports) {
$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $c9f3e130b4fb2f28$export$3915a8814b99f0b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $3GXRL = parcelRequire("3GXRL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $c9f3e130b4fb2f28$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3GXRL.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $5ZtCQ.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};
$c9f3e130b4fb2f28$export$3915a8814b99f0b.displayName = "OnboardingNudgeErrorBoundary";

});
parcelRegister("3GXRL", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $e8fc8984665e0283$export$9171acf2e93b7d4d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $iuYkJ = parcelRequire("iuYkJ");
const $e8fc8984665e0283$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $iuYkJ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};
$e8fc8984665e0283$export$9171acf2e93b7d4d.displayName = "ErrorBoundaryWithChunkErrorLogging";

});
parcelRegister("iuYkJ", function(module, exports) {
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638333d69388a906$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638333d69388a906$export$807be5f3f1ea996);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8dImz = parcelRequire("8dImz");
const $638333d69388a906$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $8dImz.isLoaderError)(error)
    });
const $638333d69388a906$export$807be5f3f1ea996 = (attributes = {})=>(0, $euxye.useCallback)((error)=>({
            ...attributes,
            ...$638333d69388a906$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("5ZtCQ", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $e9ca6c00748e0698$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e9ca6c00748e0698$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $e9ca6c00748e0698$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $e9ca6c00748e0698$export$b580da85daad7757);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $e9ca6c00748e0698$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $e9ca6c00748e0698$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $e9ca6c00748e0698$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $e9ca6c00748e0698$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $e9ca6c00748e0698$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $e9ca6c00748e0698$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $e9ca6c00748e0698$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $e9ca6c00748e0698$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e9ca6c00748e0698$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $e9ca6c00748e0698$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $e9ca6c00748e0698$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $e9ca6c00748e0698$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $e9ca6c00748e0698$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PLAN_TEAM_CAPACITY_TASK", () => $e9ca6c00748e0698$export$d324bd587f924f18);
$parcel$export(module.exports, "PLAN_PROGRAM_BOARD_TASK", () => $e9ca6c00748e0698$export$a253dd77ea687e0a);
$parcel$export(module.exports, "PLAN_RELEASE_MANAGEMENT_TASK", () => $e9ca6c00748e0698$export$bffdfa5c4de9d4b);
$parcel$export(module.exports, "PLAN_DEPENDENCY_TRACKING_TASK", () => $e9ca6c00748e0698$export$31928f71f777342f);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $e9ca6c00748e0698$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $e9ca6c00748e0698$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $e9ca6c00748e0698$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $e9ca6c00748e0698$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $e9ca6c00748e0698$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $e9ca6c00748e0698$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $e9ca6c00748e0698$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $e9ca6c00748e0698$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $e9ca6c00748e0698$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $e9ca6c00748e0698$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $e9ca6c00748e0698$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $e9ca6c00748e0698$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $e9ca6c00748e0698$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $e9ca6c00748e0698$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $e9ca6c00748e0698$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $e9ca6c00748e0698$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $e9ca6c00748e0698$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $e9ca6c00748e0698$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $e9ca6c00748e0698$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $e9ca6c00748e0698$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $e9ca6c00748e0698$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $e9ca6c00748e0698$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $e9ca6c00748e0698$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $e9ca6c00748e0698$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $e9ca6c00748e0698$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $e9ca6c00748e0698$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $e9ca6c00748e0698$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $e9ca6c00748e0698$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $e9ca6c00748e0698$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $e9ca6c00748e0698$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $e9ca6c00748e0698$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $e9ca6c00748e0698$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $e9ca6c00748e0698$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $e9ca6c00748e0698$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $e9ca6c00748e0698$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $e9ca6c00748e0698$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $e9ca6c00748e0698$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $e9ca6c00748e0698$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $e9ca6c00748e0698$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $e9ca6c00748e0698$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $e9ca6c00748e0698$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $e9ca6c00748e0698$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $e9ca6c00748e0698$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $e9ca6c00748e0698$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $e9ca6c00748e0698$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $e9ca6c00748e0698$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $e9ca6c00748e0698$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $e9ca6c00748e0698$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $e9ca6c00748e0698$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $e9ca6c00748e0698$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $e9ca6c00748e0698$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $e9ca6c00748e0698$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $e9ca6c00748e0698$export$c8ab6996f562d0db);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $e9ca6c00748e0698$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $e9ca6c00748e0698$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $e9ca6c00748e0698$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $e9ca6c00748e0698$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $e9ca6c00748e0698$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $e9ca6c00748e0698$export$5980f41aa657f9c7);
/* eslint-disable jira/filename-case */ const $e9ca6c00748e0698$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $e9ca6c00748e0698$export$2b3151a089bc8780 = 'jlove-makkuro';
const $e9ca6c00748e0698$export$6826d33e9a2c0119 = 320;
const $e9ca6c00748e0698$export$b580da85daad7757 = 'root';
const $e9ca6c00748e0698$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $e9ca6c00748e0698$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $e9ca6c00748e0698$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $e9ca6c00748e0698$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $e9ca6c00748e0698$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $e9ca6c00748e0698$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $e9ca6c00748e0698$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $e9ca6c00748e0698$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $e9ca6c00748e0698$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $e9ca6c00748e0698$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $e9ca6c00748e0698$export$63b0e55f9c6454ac = $e9ca6c00748e0698$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $e9ca6c00748e0698$export$d324bd587f924f18 = $e9ca6c00748e0698$var$completePlanTaskName('team-capacity-task');
const $e9ca6c00748e0698$export$a253dd77ea687e0a = $e9ca6c00748e0698$var$completePlanTaskName('program-board-task');
const $e9ca6c00748e0698$export$bffdfa5c4de9d4b = $e9ca6c00748e0698$var$completePlanTaskName('release-management-task');
const $e9ca6c00748e0698$export$31928f71f777342f = $e9ca6c00748e0698$var$completePlanTaskName('dependency-tracking-task');
const $e9ca6c00748e0698$export$77071b77e2801b18 = $e9ca6c00748e0698$var$completeJwmTaskName('jwm-create-project-task');
const $e9ca6c00748e0698$export$d37415ffddcf2142 = $e9ca6c00748e0698$var$completeJwmTaskName('build-form-task');
const $e9ca6c00748e0698$export$2aa6e7b6e24a04f5 = $e9ca6c00748e0698$var$completeJwmTaskName('calendar-task');
const $e9ca6c00748e0698$export$f3b53199b07af2a1 = $e9ca6c00748e0698$var$completeJwmTaskName('timeline-task');
const $e9ca6c00748e0698$export$b52a7c936684cfc5 = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-import');
const $e9ca6c00748e0698$export$b5555f24061f9fb = $e9ca6c00748e0698$var$completeJwmTaskName('summary-and-reports-task');
const $e9ca6c00748e0698$export$ff25449f34b8abf = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $e9ca6c00748e0698$export$3380e677209260fe = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-key-differences');
const $e9ca6c00748e0698$export$da23b72d32bfad9e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $e9ca6c00748e0698$export$4b064659282e0238 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $e9ca6c00748e0698$export$3ab51851f6d823e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $e9ca6c00748e0698$export$e4a1a37a9a1350ad = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $e9ca6c00748e0698$export$b7f7da5e795f0327 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $e9ca6c00748e0698$export$80a401c1aa47a377 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $e9ca6c00748e0698$export$934ac7a251b26dc7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$4634f6395df3ebbe = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $e9ca6c00748e0698$export$768fb41107a1e8d7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $e9ca6c00748e0698$export$d797a81bace17184 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $e9ca6c00748e0698$export$746102c94db9df1f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$5f1efd797d65e349 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $e9ca6c00748e0698$export$cccc812ccafbf11f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$64822db87abd8a47 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $e9ca6c00748e0698$export$64f764d8be495c82 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $e9ca6c00748e0698$export$24eae23dc1c68bbd = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $e9ca6c00748e0698$export$50fa92eba6f82feb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $e9ca6c00748e0698$export$4155d22fe3f14cd6 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $e9ca6c00748e0698$export$76813cbead887191 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$90aab2ff89daf770 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $e9ca6c00748e0698$export$a2bc0cbad2e6e605 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$f90872a1280728bb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$bce644e96518cbd2 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$241aaebffac0a3e5 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $e9ca6c00748e0698$export$f9dfc43b5b31c4b7 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $e9ca6c00748e0698$export$79759e9e62fb9312 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $e9ca6c00748e0698$export$992d1e0dce255d19 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $e9ca6c00748e0698$export$d28c1b0e5b3e768 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $e9ca6c00748e0698$export$ca714ee197bed4ec = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$faae55ceea4b6073 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $e9ca6c00748e0698$export$200bc24cd120667e = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $e9ca6c00748e0698$export$a0d784a48b4e886c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$baf5bd09b4b33b8a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $e9ca6c00748e0698$export$4702007eedbca8ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$aa9d2d635ea63898 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $e9ca6c00748e0698$export$2ea449225c1f6cac = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $e9ca6c00748e0698$export$deb8b557e735e26a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $e9ca6c00748e0698$export$d45754df44e4c309 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $e9ca6c00748e0698$export$78b2913b550edbb = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$71243272608c58ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $e9ca6c00748e0698$export$39a08f215c33bc39 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$d2377f6a6fa3b49c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$befa8f6533309779 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $e9ca6c00748e0698$export$736b40db8701ba6c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$11eff6ae2f70b67b = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $e9ca6c00748e0698$export$fb2d23e5315a67a9 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $e9ca6c00748e0698$export$32e794bb49d60b6 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $e9ca6c00748e0698$export$fed256238b27db06 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $e9ca6c00748e0698$export$132eecb4d35a590d = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $e9ca6c00748e0698$export$2579c51cadd45eca = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $e9ca6c00748e0698$export$4b1a0cefa966ea0 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $e9ca6c00748e0698$export$f6558daacc312a65 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $e9ca6c00748e0698$export$925efa2e24e86b88 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $e9ca6c00748e0698$export$40454d3e062dcd44 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $e9ca6c00748e0698$export$99b0e09ff6f00490 = $e9ca6c00748e0698$var$completeJsmTaskName('customize-your-request-types-task');
const $e9ca6c00748e0698$export$2a82344eb273eeff = $e9ca6c00748e0698$var$completeJsmTaskName('review-your-channels-task');
const $e9ca6c00748e0698$export$1de5766b7e640d6b = $e9ca6c00748e0698$var$completeJsmTaskName('invite-your-team-task');
const $e9ca6c00748e0698$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $e9ca6c00748e0698$export$c8ab6996f562d0db = 'accountId';
const $e9ca6c00748e0698$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $e9ca6c00748e0698$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $e9ca6c00748e0698$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $e9ca6c00748e0698$export$38fbac7a5bf4aa33 = [
    $e9ca6c00748e0698$export$2a82344eb273eeff,
    $e9ca6c00748e0698$export$99b0e09ff6f00490,
    $e9ca6c00748e0698$export$1de5766b7e640d6b
];
const $e9ca6c00748e0698$export$7578902c7f420a3 = [
    $e9ca6c00748e0698$export$63b0e55f9c6454ac,
    $e9ca6c00748e0698$export$77071b77e2801b18,
    $e9ca6c00748e0698$export$d37415ffddcf2142,
    $e9ca6c00748e0698$export$b52a7c936684cfc5,
    $e9ca6c00748e0698$export$b5555f24061f9fb,
    $e9ca6c00748e0698$export$ff25449f34b8abf,
    $e9ca6c00748e0698$export$3380e677209260fe,
    $e9ca6c00748e0698$export$da23b72d32bfad9e,
    $e9ca6c00748e0698$export$4b064659282e0238,
    $e9ca6c00748e0698$export$3ab51851f6d823e,
    $e9ca6c00748e0698$export$e4a1a37a9a1350ad,
    $e9ca6c00748e0698$export$b7f7da5e795f0327,
    $e9ca6c00748e0698$export$80a401c1aa47a377,
    $e9ca6c00748e0698$export$934ac7a251b26dc7,
    $e9ca6c00748e0698$export$4634f6395df3ebbe,
    $e9ca6c00748e0698$export$768fb41107a1e8d7,
    $e9ca6c00748e0698$export$d797a81bace17184,
    $e9ca6c00748e0698$export$746102c94db9df1f,
    $e9ca6c00748e0698$export$5f1efd797d65e349,
    $e9ca6c00748e0698$export$cccc812ccafbf11f,
    $e9ca6c00748e0698$export$64822db87abd8a47,
    $e9ca6c00748e0698$export$64f764d8be495c82,
    $e9ca6c00748e0698$export$24eae23dc1c68bbd,
    $e9ca6c00748e0698$export$50fa92eba6f82feb,
    $e9ca6c00748e0698$export$4155d22fe3f14cd6,
    $e9ca6c00748e0698$export$76813cbead887191,
    $e9ca6c00748e0698$export$90aab2ff89daf770,
    $e9ca6c00748e0698$export$a2bc0cbad2e6e605,
    $e9ca6c00748e0698$export$f90872a1280728bb,
    $e9ca6c00748e0698$export$bce644e96518cbd2,
    $e9ca6c00748e0698$export$241aaebffac0a3e5,
    $e9ca6c00748e0698$export$f9dfc43b5b31c4b7,
    $e9ca6c00748e0698$export$79759e9e62fb9312,
    $e9ca6c00748e0698$export$992d1e0dce255d19,
    $e9ca6c00748e0698$export$d28c1b0e5b3e768,
    $e9ca6c00748e0698$export$ca714ee197bed4ec,
    $e9ca6c00748e0698$export$faae55ceea4b6073,
    $e9ca6c00748e0698$export$200bc24cd120667e,
    $e9ca6c00748e0698$export$a0d784a48b4e886c,
    $e9ca6c00748e0698$export$baf5bd09b4b33b8a,
    $e9ca6c00748e0698$export$4702007eedbca8ab,
    $e9ca6c00748e0698$export$aa9d2d635ea63898,
    $e9ca6c00748e0698$export$2ea449225c1f6cac,
    $e9ca6c00748e0698$export$deb8b557e735e26a,
    $e9ca6c00748e0698$export$d45754df44e4c309,
    $e9ca6c00748e0698$export$78b2913b550edbb,
    $e9ca6c00748e0698$export$71243272608c58ab,
    $e9ca6c00748e0698$export$39a08f215c33bc39,
    $e9ca6c00748e0698$export$d2377f6a6fa3b49c,
    $e9ca6c00748e0698$export$befa8f6533309779,
    $e9ca6c00748e0698$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $e9ca6c00748e0698$export$11eff6ae2f70b67b,
    $e9ca6c00748e0698$export$fb2d23e5315a67a9,
    $e9ca6c00748e0698$export$32e794bb49d60b6,
    $e9ca6c00748e0698$export$fed256238b27db06,
    $e9ca6c00748e0698$export$132eecb4d35a590d,
    $e9ca6c00748e0698$export$2579c51cadd45eca,
    $e9ca6c00748e0698$export$4b1a0cefa966ea0,
    $e9ca6c00748e0698$export$f6558daacc312a65,
    $e9ca6c00748e0698$export$925efa2e24e86b88,
    $e9ca6c00748e0698$export$40454d3e062dcd44
];
const $e9ca6c00748e0698$export$5980f41aa657f9c7 = [
    'SAM1'
];

});


parcelRegister("78ZxQ", function(module, exports) {
$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $b12a5e09957dfa55$export$b687eb4905cdc15a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $11VMX = parcelRequire("11VMX");
const $b12a5e09957dfa55$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $11VMX.useHasOpened)();
    return hasOpened;
};

});
parcelRegister("11VMX", function(module, exports) {
$parcel$export(module.exports, "useHasOpened", () => $cef4dc00e5865d98$export$cbaabcded53b5c1f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $5vUJG = parcelRequire("5vUJG");
const $cef4dc00e5865d98$var$actions = {
    setHasOpened: $5vUJG.setHasOpened
};
const $cef4dc00e5865d98$var$initialState = {
    hasOpened: false
};
const $cef4dc00e5865d98$var$Store = (0, $5QDqc.createStore)({
    initialState: $cef4dc00e5865d98$var$initialState,
    actions: $cef4dc00e5865d98$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $cef4dc00e5865d98$export$cbaabcded53b5c1f = (0, $3h1FP.createHook)($cef4dc00e5865d98$var$Store);

});
parcelRegister("5vUJG", function(module, exports) {
$parcel$export(module.exports, "setHasOpened", () => $2af725793541a0e6$export$c4743c64a7c42294);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2af725793541a0e6$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $2af725793541a0e6$export$2e2bcd8739ae039 = $2af725793541a0e6$export$c4743c64a7c42294;

});



parcelRegister("eiMVP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4cUSg").then(()=>parcelRequire('59Kf9'));

});


parcelRegister("j154p", function(module, exports) {
$parcel$export(module.exports, "Create", () => $2b5b7f5c5d177e73$export$8ade6fcbf3a7de5d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $joEdY = parcelRequire("joEdY");

var $7QyVm = parcelRequire("7QyVm");

var $ihEDU = parcelRequire("ihEDU");

var $6Z9mq = parcelRequire("6Z9mq");

const $2b5b7f5c5d177e73$export$8ade6fcbf3a7de5d = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { onClick: onClick, text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7QyVm.SpotlightTarget), {
        name: (0, $joEdY.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Z9mq.CreateButton), {
        ref: ref,
        onClick: onClick,
        testId: (0, $9fd4622c0d378237$export$bac9f330cf4670e8)
    }, text)));
});

});
parcelRegister("joEdY", function(module, exports) {
$parcel$export(module.exports, "REPO_TYPE", () => $801d21e3e83376ab$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $801d21e3e83376ab$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $801d21e3e83376ab$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $801d21e3e83376ab$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $801d21e3e83376ab$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $801d21e3e83376ab$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $801d21e3e83376ab$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $801d21e3e83376ab$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $801d21e3e83376ab$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $801d21e3e83376ab$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $801d21e3e83376ab$export$dde074e512e80dff);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $801d21e3e83376ab$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $801d21e3e83376ab$export$f57650e6e7be03dc);
/* eslint-disable jira/filename-case */ const $801d21e3e83376ab$export$399c7e6858236b4 = 'source.code.link';
const $801d21e3e83376ab$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $801d21e3e83376ab$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $801d21e3e83376ab$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $801d21e3e83376ab$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $801d21e3e83376ab$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $801d21e3e83376ab$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $801d21e3e83376ab$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $801d21e3e83376ab$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $801d21e3e83376ab$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $801d21e3e83376ab$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $801d21e3e83376ab$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $801d21e3e83376ab$export$dde074e512e80dff = 'global-create-spotlight';
const $801d21e3e83376ab$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $801d21e3e83376ab$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $801d21e3e83376ab$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});

parcelRegister("7QyVm", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $35b08adbbb9f3c1e$export$e29577842f211e22);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $8jEW8 = parcelRequire("8jEW8");
const $35b08adbbb9f3c1e$export$e29577842f211e22 = (t0)=>{
    const $ = (0, $e7boj.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const t1 = `ak-spotlight-target-${props.name}`;
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
            "data-testid": t1
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== props || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8jEW8.default), props, t2);
        $[6] = props;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
$35b08adbbb9f3c1e$export$e29577842f211e22.displayName = "SpotlightTarget";

});

parcelRegister("6Z9mq", function(module, exports) {
$parcel$export(module.exports, "CreateButton", () => $58146c3e703c3f27$export$6d3c345ce7c38fd9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ikOED = parcelRequire("ikOED");

var $8a8ab = parcelRequire("8a8ab");
const $58146c3e703c3f27$export$6d3c345ce7c38fd9 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, onClick: onClick, testId: testId, interactionName: interactionName }, ref)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8a8ab.Button), {
        ref: ref,
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ikOED))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    }));

});
parcelRegister("ikOED", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c8c278364bf9855efef1638d78d6588>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d591632dd4c0a235$var$_react = $d591632dd4c0a235$var$_interopRequireDefault((parcelRequire("euxye")));

var $d591632dd4c0a235$var$_baseNew = $d591632dd4c0a235$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $d591632dd4c0a235$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d591632dd4c0a235$var$AddIcon = (props)=>/*#__PURE__*/ $d591632dd4c0a235$var$_react.default.createElement($d591632dd4c0a235$var$_baseNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$d591632dd4c0a235$var$AddIcon.displayName = 'AddIcon';
var $d591632dd4c0a235$var$_default = module.exports.default = $d591632dd4c0a235$var$AddIcon;

});


/* eslint-disable jira/filename-case */ // This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
const $9fd4622c0d378237$export$bac9f330cf4670e8 = 'atlassian-navigation--create-button';


parcelRegister("eSXdz", function(module, exports) {
$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $23a9ee8e621761df$export$8a73e89ffc4b9342);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $23a9ee8e621761df$var$initialState = {
    isInitialLoad: true
};
const $23a9ee8e621761df$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $23a9ee8e621761df$var$store = (0, $5QDqc.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $23a9ee8e621761df$var$initialState,
    actions: $23a9ee8e621761df$export$e324594224ef24da
});
const $23a9ee8e621761df$export$8a73e89ffc4b9342 = (0, $3h1FP.createHook)($23a9ee8e621761df$var$store);

});

parcelRegister("bpQLU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6f84d10acb8badf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $8wV9L = parcelRequire("8wV9L");

var $i860n = parcelRequire("i860n");

var $88rm3 = parcelRequire("88rm3");
const $d6f84d10acb8badf$var$onCreateClick = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $88rm3.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $8wV9L.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $i860n.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api?.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api?.showCreateDialog({});
        (0, $88rm3.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};
var $d6f84d10acb8badf$export$2e2bcd8739ae039 = $d6f84d10acb8badf$var$onCreateClick;

});
parcelRegister("8wV9L", function(module, exports) {
$parcel$export(module.exports, "loadBridge", () => $027eb0ac044c2f18$export$df8409da353bde5a);
/* eslint-disable jira/filename-case */ 
var $1fD9L = parcelRequire("1fD9L");
var $bAzzc = parcelRequire("bAzzc");
var $9wvOm = parcelRequire("9wvOm");
var $9dWMe = parcelRequire("9dWMe");

var $9dWMe = parcelRequire("9dWMe");
var $8IotF = parcelRequire("8IotF");
var $erQjo = parcelRequire("erQjo");
var $3i0O3 = parcelRequire("3i0O3");
var $UC9tJ = parcelRequire("UC9tJ");
const $027eb0ac044c2f18$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $1fD9L.MAX_RETRIES), timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $9dWMe.loadBridgeStrict)({
        name: name,
        // oxlint-disable-next-line typescript/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $bAzzc.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $9wvOm.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("1fD9L", function(module, exports) {
$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $31c65cd7c39d7bf1$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $31c65cd7c39d7bf1$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $31c65cd7c39d7bf1$export$37f20f0ff732fcd7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
const $31c65cd7c39d7bf1$export$f19a2d31722e3428 = (0, $6CfY5.default).safeErrorWithoutCustomerData;
const $31c65cd7c39d7bf1$export$ea810ce67e3c8eac = (0, $6CfY5.default).safeInfoWithoutCustomerData;
const $31c65cd7c39d7bf1$export$1f86472c1374185a = 40;
const $31c65cd7c39d7bf1$export$7bd623b29ec8e1eb = 500;
const $31c65cd7c39d7bf1$export$37f20f0ff732fcd7 = true;

});

parcelRegister("bAzzc", function(module, exports) {
$parcel$export(module.exports, "loadBridgeBail", () => $da55d3b5c4f426b2$export$a036f92c2465504e);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $1fD9L = parcelRequire("1fD9L");
const $da55d3b5c4f426b2$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>{
    try {
        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    /* oxlint-enable typescript/consistent-type-assertions */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $b3AOE.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("b3AOE", function(module, exports) {
$parcel$export(module.exports, "safeStringify", () => $575c3794295cd43c$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
const $575c3794295cd43c$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("9wvOm", function(module, exports) {
$parcel$export(module.exports, "loadBridgeRace", () => $a14da4be2750bb9b$export$20c32b4579d78b92);
/* eslint-disable jira/filename-case */ 
var $bAzzc = parcelRequire("bAzzc");

var $8IotF = parcelRequire("8IotF");

var $1fD9L = parcelRequire("1fD9L");
const $a14da4be2750bb9b$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $1fD9L.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $8IotF.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $bAzzc.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("8IotF", function(module, exports) {
$parcel$export(module.exports, "loadBridgeWeak", () => $cba106b8f70516b2$export$3cefda82396756a1);
/* eslint-disable jira/filename-case */ 
var $dWTea = parcelRequire("dWTea");
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
let $cba106b8f70516b2$var$pollingSingleton = null;
const $cba106b8f70516b2$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $cba106b8f70516b2$var$pollingSingleton ?? (0, $dWTea.createPollingCollection)((v)=>window.require(v), 100);
    $cba106b8f70516b2$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("dWTea", function(module, exports) {
$parcel$export(module.exports, "createPollingCollection", () => $7de7057d4b7e1c62$export$f163446a982a8077);
/* eslint-disable jira/filename-case */ 
var $1uH7N = parcelRequire("1uH7N");

var $aA3A5 = parcelRequire("aA3A5");
const $7de7057d4b7e1c62$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $1uH7N.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aA3A5.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aA3A5.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // oxlint-disable-next-line typescript/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aA3A5", function(module, exports) {
$parcel$export(module.exports, "default", () => $abfaf64ce8ef144a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $abfaf64ce8ef144a$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $abfaf64ce8ef144a$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // oxlint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}
$abfaf64ce8ef144a$export$2e2bcd8739ae039.displayName = "Deferred";

});




parcelRegister("9dWMe", function(module, exports) {
$parcel$export(module.exports, "loadBridgeStrict", () => $e2d66ceeb4b43693$export$eba600d28decc4ac);
/* eslint-disable jira/filename-case */ 
var $fEmTm = parcelRequire("fEmTm");

var $6bEm8 = parcelRequire("6bEm8");

var $i860n = parcelRequire("i860n");

var $9MneQ = parcelRequire("9MneQ");

var $9wvOm = parcelRequire("9wvOm");

var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");

var $erQjo = parcelRequire("erQjo");
const $e2d66ceeb4b43693$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR), isolatedFromHeritage: isolatedFromHeritage = false })=>{
    (0, $9MneQ.saveStats)(name, wrmKeys);
    if (// FIXME: remove fg after initial rollout
    // eslint-disable-next-line jira/ff/no-preconditioning
    !isolatedFromHeritage && (0, $i860n.fg)('jfp_magma_jira-report-early-strict-bridge') && (0, $6bEm8.default)('ajs-environment') === 'staging') {
        if (!(0, $erQjo.isWRMHeritageLoaded)()) (0, $fEmTm.captureException)(`loadBridgeStrict:${name}`, new Error('Do not call loadBridgeStrict without waitForHeritage'));
    }
    try {
        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    /* oxlint-enable typescript/consistent-type-assertions */ // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $f39gG.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $9wvOm.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("9MneQ", function(module, exports) {
$parcel$export(module.exports, "saveStats", () => $154e3b1b7c5d8d00$export$9ea3ff7978093559);
/* eslint-disable jira/filename-case */ const $154e3b1b7c5d8d00$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // oxlint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // oxlint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $154e3b1b7c5d8d00$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $154e3b1b7c5d8d00$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $154e3b1b7c5d8d00$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $154e3b1b7c5d8d00$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $154e3b1b7c5d8d00$var$initStats();
        // stop accumulating stats at TTI mark
        if ($154e3b1b7c5d8d00$var$isPageInteractive()) return;
        stats.requests += 1;
        $154e3b1b7c5d8d00$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$154e3b1b7c5d8d00$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $154e3b1b7c5d8d00$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("f39gG", function(module, exports) {
$parcel$export(module.exports, "loadWrmResources", () => $753a8f7d9232d897$export$6cda16b6eff75f59);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $ktkIs = parcelRequire("ktkIs");

var $8IotF = parcelRequire("8IotF");

var $1fD9L = parcelRequire("1fD9L");
const $753a8f7d9232d897$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $8IotF.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $ktkIs.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $1fD9L.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $b3AOE.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("ktkIs", function(module, exports) {
$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $016f2bde0e3a1ef7$export$93d9db5fbabad1b0);
/* eslint-disable jira/filename-case */ 
var $6Z3wy = parcelRequire("6Z3wy");
let $016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded = false;
const $016f2bde0e3a1ef7$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $016f2bde0e3a1ef7$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded || $016f2bde0e3a1ef7$var$isOnRapidBoardsPage()) return wrmKeys;
    $016f2bde0e3a1ef7$var$isSuperBatchDependenciesLoaded = true;
    return (0, $6Z3wy.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("6Z3wy", function(module, exports) {
$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $ca21c54a2634c804$export$f14a6b583ce9e077);
/* eslint-disable jira/filename-case */ const $ca21c54a2634c804$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});



parcelRegister("erQjo", function(module, exports) {
$parcel$export(module.exports, "isWRMHeritageLoaded", () => $7a0b36f6a0f344fd$export$1a2b9c2d0a3d83ed);
$parcel$export(module.exports, "waitForHeritage", () => $7a0b36f6a0f344fd$export$c61060338d026f78);
/* eslint-disable jira/filename-case */ 
var $44A5J = parcelRequire("44A5J");

var $aA3A5 = parcelRequire("aA3A5");
let $7a0b36f6a0f344fd$var$heritageIsLoaded = false;
const $7a0b36f6a0f344fd$export$1a2b9c2d0a3d83ed = ()=>$7a0b36f6a0f344fd$var$heritageIsLoaded;
const $7a0b36f6a0f344fd$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        $7a0b36f6a0f344fd$var$heritageIsLoaded = false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aA3A5.default)();
        (0, $44A5J.bootstrapWrmClient)().then(()=>{
            $7a0b36f6a0f344fd$var$heritageIsLoaded = true;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("44A5J", function(module, exports) {
$parcel$export(module.exports, "bootstrapWrmClient", () => $dc731f2745b60094$export$d001f71dd306cb0c);
/* eslint-disable jira/filename-case */ 
var $b3AOE = parcelRequire("b3AOE");

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
const $dc731f2745b60094$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $dc731f2745b60094$var$fetchSpaWrmContext = async ()=>{
    return (0, $4fhEY.default)($dc731f2745b60094$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $dc731f2745b60094$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $dc731f2745b60094$var$hasWrmInitialised;
const $dc731f2745b60094$var$runBootstrap = ()=>{
    const spaWrmContext = $dc731f2745b60094$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // oxlint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($dc731f2745b60094$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                error: new Error((0, $b3AOE.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $dc731f2745b60094$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($dc731f2745b60094$var$hasWrmInitialised) return $dc731f2745b60094$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $dc731f2745b60094$var$hasWrmInitialised = Promise.resolve();
    else $dc731f2745b60094$var$hasWrmInitialised = $dc731f2745b60094$var$runBootstrap();
    return $dc731f2745b60094$var$hasWrmInitialised;
};

});



parcelRegister("3i0O3", function(module, exports) {
$parcel$export(module.exports, "wrmRequire", () => $ad614e51c09a2912$export$cc9d8f51375ef66a);
/* eslint-disable jira/filename-case */ 
var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");
const $ad614e51c09a2912$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $f39gG.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("UC9tJ", function(module, exports) {
$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $73b86a7d365a8248$export$e53a5db19a39ed2f);
/* eslint-disable jira/filename-case */ 
var $f39gG = parcelRequire("f39gG");

var $1fD9L = parcelRequire("1fD9L");
const $73b86a7d365a8248$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $1fD9L.SHOULD_LOG_ERROR))=>(0, $f39gG.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("88rm3", function(module, exports) {
$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $8bfa555f49653eee$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $8bfa555f49653eee$export$b5c5d408bb7fd104);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hWSCW = parcelRequire("hWSCW");

var $fCMl0 = parcelRequire("fCMl0");
const $8bfa555f49653eee$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $fCMl0.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $fCMl0.legacyIssueCreateTransitionInteraction).start();
        (0, $fCMl0.legacyIssueCreateCombinedInteraction).start();
    }
};
const $8bfa555f49653eee$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $hWSCW.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $fCMl0.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $fCMl0.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $fCMl0.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("hWSCW", function(module, exports) {
$parcel$export(module.exports, "apiReady", () => $34bbeb50fc95c2eb$export$330fb1a04c974aad);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/wrm/no-load-bridge

var $8wV9L = parcelRequire("8wV9L");
let $34bbeb50fc95c2eb$var$currentBridge;
const $34bbeb50fc95c2eb$export$330fb1a04c974aad = async ()=>{
    if ($34bbeb50fc95c2eb$var$currentBridge) return $34bbeb50fc95c2eb$var$currentBridge;
    /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/wrm/no-load-bridge
    const Events = await (0, $8wV9L.loadBridge)({
        /* oxlint-enable typescript/consistent-type-assertions */ name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $34bbeb50fc95c2eb$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("fCMl0", function(module, exports) {
$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $48f0ac295f595fe6$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $48f0ac295f595fe6$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $48f0ac295f595fe6$export$52353a8848646ccd);
/* eslint-disable jira/filename-case */ 
var $jvGCa = parcelRequire("jvGCa");
const $48f0ac295f595fe6$export$2bc24132dfd54487 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $48f0ac295f595fe6$export$ba0054dee3105c90 = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $48f0ac295f595fe6$export$52353a8848646ccd = (0, $jvGCa.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



/* eslint-disable jira/filename-case */ const $42000e90ec1a6081$export$d983e94cf86f65d = 'global-create-button';
const $42000e90ec1a6081$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("kFDmj", function(module, exports) {
$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $530e5ba73be91b3b$export$9086117e14a55509);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $l2ZRY = parcelRequire("l2ZRY");

var $7Odw0 = parcelRequire("7Odw0");

var $9Oo0T = parcelRequire("9Oo0T");

var $2b39L = parcelRequire("2b39L");
const $530e5ba73be91b3b$export$9086117e14a55509 = ()=>{
    const $ = (0, $e7boj.c)(15);
    const [t0, t1] = (0, $9Oo0T.useTriggerIssueCreateModal)();
    const { shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight } = t0;
    const { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView } = t1;
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const hasUserSeenMiniModal = (0, $euxye.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $l2ZRY.usePersistentIssueCreateModalViewResource)();
    let t2;
    if ($[0] !== resource?.view || $[1] !== setPersistentModalView) {
        t2 = ()=>{
            setPersistentModalView(resource?.view || "modal");
        };
        $[0] = resource?.view;
        $[1] = setPersistentModalView;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[3] = t3;
    } else t3 = $[3];
    (0, $euxye.useEffect)(t2, t3);
    let t4;
    if ($[4] !== isJSM || $[5] !== resource?.isDiscoPushComplete || $[6] !== setShouldPushMiniModalDiscoverability) {
        t4 = ()=>{
            if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
            else setShouldPushMiniModalDiscoverability(!isJSM && !(0, $7Odw0.isSupportedUserAgent)());
        };
        $[4] = isJSM;
        $[5] = resource?.isDiscoPushComplete;
        $[6] = setShouldPushMiniModalDiscoverability;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = resource?.isDiscoPushComplete;
    let t6;
    if ($[8] !== isJSM || $[9] !== setShouldPushMiniModalDiscoverability || $[10] !== t5) {
        t6 = [
            t5,
            setShouldPushMiniModalDiscoverability,
            isJSM
        ];
        $[8] = isJSM;
        $[9] = setShouldPushMiniModalDiscoverability;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    (0, $euxye.useEffect)(t4, t6);
    let t7;
    let t8;
    if ($[12] !== shouldShowMiniModalSpotlight) {
        t7 = ()=>{
            if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
        };
        t8 = [
            shouldShowMiniModalSpotlight
        ];
        $[12] = shouldShowMiniModalSpotlight;
        $[13] = t7;
        $[14] = t8;
    } else {
        t7 = $[13];
        t8 = $[14];
    }
    (0, $euxye.useEffect)(t7, t8);
    return null;
};

});
parcelRegister("l2ZRY", function(module, exports) {
$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $2c64d8938b349ba0$export$20dbed3226e737bc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

var $k6ufm = parcelRequire("k6ufm");


var $gjifS = parcelRequire("gjifS");
const $2c64d8938b349ba0$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $gjifS.persistentIssueCreateModalViewResource));
    const updateView = (0, $euxye.useCallback)(async (view)=>{
        try {
            await (0, $fNXFu.userPreferenceAPI).set((0, $197033e503119526$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $euxye.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $fNXFu.userPreferenceAPI).set((0, $197033e503119526$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
/* eslint-disable jira/filename-case */ const $197033e503119526$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $197033e503119526$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $197033e503119526$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';


parcelRegister("9Oo0T", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $dcd926d39f5bb8db$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "noopActions", () => $dcd926d39f5bb8db$export$6b9306855551af21);
$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $dcd926d39f5bb8db$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $dcd926d39f5bb8db$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $dcd926d39f5bb8db$export$558a195c5bfe3787);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $7TA2J = parcelRequire("7TA2J");

var $jaJSD = parcelRequire("jaJSD");

var $7IK6V = parcelRequire("7IK6V");

var $14CWj = parcelRequire("14CWj");

var $cIX5T = parcelRequire("cIX5T");

var $VoOhq = parcelRequire("VoOhq");

var $i860n = parcelRequire("i860n");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $4BBh0 = parcelRequire("4BBh0");
var $inMxE = parcelRequire("inMxE");

var $2700E = parcelRequire("2700E");

var $1OTgk = parcelRequire("1OTgk");

var $jwOsd = parcelRequire("jwOsd");

var $kTMHb = parcelRequire("kTMHb");

var $k2847 = parcelRequire("k2847");
const $dcd926d39f5bb8db$var$traceModernisedGicPress = (isSubsequentLoad)=>{
    if ((0, $i860n.fg)('nike_united_fix_ufo_error')) return;
    if (isSubsequentLoad) (0, $VoOhq.default)('global-issue.create-modal-modernised-subsequent');
    else (0, $VoOhq.default)('global-issue.create-modal-modernised');
};
const $dcd926d39f5bb8db$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $7IK6V.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1OTgk.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null,
    // reference to the element to focus when the modal is closed
    returnFocusRef: undefined,
    // when true, indicates the user was redirected from the modern modal to the old modal (e.g., for unsupported project types)
    isRedirectedFromModernModal: false,
    // when true, a transition between old and new modal is in progress
    isTransitioningBetweenOldAndNewModal: false,
    shouldUseLegacyCreateExperience: false,
    // controls whether GIC creates an issue on submit or fires onSaveEditsWithoutIssueCreation.
    submitBehaviour: (0, $kTMHb.ISSUE_CREATE_SUBMIT_BEHAVIOUR).CREATE_ISSUE,
    // called with the full form field payload when submitBehaviour is 'saveEditsWithoutIssueCreation' and the user clicks the submit button. No issue is created in this case.
    onSaveEditsWithoutIssueCreation: undefined
};
const $dcd926d39f5bb8db$export$e324594224ef24da = {
    restoreState: (stateToRestore, isTransitioningBetweenExistingAndNewModal)=>({ setState: setState, getState: getState })=>{
            // During modal transitions (switchToModernModal / triggerFallbackToOldModal),
            // skip restore entirely to prevent stale draft data from overwriting the transition state.
            if (isTransitioningBetweenExistingAndNewModal && (0, $i860n.fg)('create_work_item_modernization')) return;
            // If the user just discarded the existing GIC (wasModalRetriggered was reset to false),
            // skip restoring stale IndexedDB state that still has wasModalRetriggered: true.
            // This prevents the discard modal and docked view from reopening after discard.
            const currentState = getState();
            if (!currentState.wasModalRetriggered && stateToRestore.wasModalRetriggered && (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false)) return;
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) {
                const isModernisedTrigger = Boolean(stateToRestore.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(stateToRestore.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(isSubsequentLoad);
            }
            // Don't let stale persisted state close a modal that was just opened.
            // The openIssueCreateModal action sets isModalOpen inside a setTimeout(0),
            // and restoreState from IndexedDB can race and overwrite it.
            if (isModalOpen && !stateToRestore.isModalOpen && (0, $i860n.fg)('bug-fix_gic_restore_state_race_condition')) return;
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                const isModernisedTrigger = Boolean(nextState?.triggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextState.triggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts && !(0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false);
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $k2847.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $dcd926d39f5bb8db$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                /*
				 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
				 * so that we can store the reference of this
				 * and use that to re-focus the button whenever the modal is closed
				 */ let triggerButton;
                const handleButtonClick = (event)=>{
                    // oxlint-disable-next-line typescript/consistent-type-assertions
                    const triggerButtonTarget = event.target;
                    triggerButton = triggerButtonTarget?.closest('button');
                    triggerButton?.focus();
                };
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.addEventListener('click', handleButtonClick);
                setTimeout(()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.removeEventListener('click', handleButtonClick);
                }, 0);
                setTimeout(()=>{
                    setState({
                        ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, $k2847.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, $7TA2J.v4)(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey,
                        ...nextState,
                        /* oxlint-disable typescript/consistent-type-assertions */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        triggerButtonRef: triggerButton || document.activeElement
                    });
                }, 0);
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $k2847.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $jaJSD.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    triggerFallbackToOldModal: (project, options)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                isTransitioningBetweenOldAndNewModal: true,
                ...options?.forceLegacyCreateExperience && {
                    shouldUseLegacyCreateExperience: true
                },
                payload: options?.forceLegacyCreateExperience ? {
                    ...currentState.payload,
                    project: {
                        projectId: project.value,
                        projectType: project.projectType
                    }
                } : {
                    project: {
                        projectId: project.value,
                        projectType: project.projectType
                    }
                }
            });
        },
    /**
	 * Switches from the old modal to the modern modal by closing and reopening.
	 * Uses a single setState to avoid intermediate renders where payload is cleared.
	 * Publishes MODAL_CLOSED to clean up the old in-progress issue from IndexedDB
	 * so stale draft data isn't restored after the transition.
	 */ switchToModernModal: (project)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // Clean up the old in-progress issue from IndexedDB before switching
            const { publish: publish } = (0, $cIX5T.getGICLifeCycleEvents)();
            publish((0, $14CWj.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
                inProgressIssueID: currentState.inProgressIssueID ?? '',
                createdIssues: []
            });
            (0, $k2847.startGlobalIssueCreateMetrics)(true, true);
            $dcd926d39f5bb8db$var$traceModernisedGicPress(true);
            // Reset to initial state but immediately set the new modal state in a single setState
            // to avoid intermediate renders where payload is cleared
            setState({
                ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                isModalOpen: true,
                isSubsequentLoad: true,
                isTransitioningBetweenOldAndNewModal: true,
                shouldInitFetchConfig: true,
                triggerPointKey: currentState.triggerPointKey,
                payload: {
                    project: {
                        projectId: project.value,
                        projectType: project.projectType,
                        isSimplified: project.isSimplified
                    }
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                const nextTriggerPointKey = currentState.openIssueCreateModalNextState?.triggerPointKey ?? currentState.triggerPointKey;
                const isModernisedTrigger = Boolean(nextTriggerPointKey && (0, $k2847.shouldTriggerModernisedIssueCreate)(nextTriggerPointKey));
                (0, $k2847.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad, isModernisedTrigger);
                if (isModernisedTrigger) $dcd926d39f5bb8db$var$traceModernisedGicPress(currentState.isSubsequentLoad);
                setState({
                    ...$dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $dcd926d39f5bb8db$export$6b9306855551af21 = {
    restoreState: (_stateToRestore, _isTransitioningBetweenExistingAndNewModal)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    openIssueCreateModal: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    closeIssueCreateModal: (_hasIssueCreated)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    triggerFallbackToOldModal: (_project, _options)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    switchToModernModal: (_project)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    clearSectionMessage: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setDisplayOnlyRequiredFields: (_nextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setMinimizableModalView: (_minimizableModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    resetWasModalRetriggered: (_applyNextState)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    resetShouldInitFetchConfig: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setCallbackPayload: (_callbackPayload)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setShouldPushMiniModalDiscoverability: (_shouldPushMiniModalDiscoverability)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    dismissModalSpotlight: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setPersistentModalView: (_persistentModalView)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    removeAlertFromAlertsToBeLinked: (_alertId)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))(),
    setSessionId: (_sessionId)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))()
};
const $dcd926d39f5bb8db$var$store = (0, $5QDqc.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $dcd926d39f5bb8db$export$d4c72bab9d6cc13a,
    actions: $dcd926d39f5bb8db$export$e324594224ef24da
});
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState = (0, $3h1FP.createStateHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions = (0, $3h1FP.createActionsHook)($dcd926d39f5bb8db$var$store);
const $dcd926d39f5bb8db$export$71e0eb7b8a91a156 = ()=>{
    const createState = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalState();
    const createActions = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $euxye.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $dcd926d39f5bb8db$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $dcd926d39f5bb8db$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $jwOsd.useSitePickerContext)();
    return (0, $euxye.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $4BBh0.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $dcd926d39f5bb8db$export$4c674fe824b8f278 = (0, $iGu4q.createSubscriber)($dcd926d39f5bb8db$var$store);
function $dcd926d39f5bb8db$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $dcd926d39f5bb8db$export$71e0eb7b8a91a156();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: true,
            ...props
        });
    };
}

});
parcelRegister("jaJSD", function(module, exports) {
$parcel$export(module.exports, "CreateIssueUFOExperience", () => $b158ee0e69f56076$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $b158ee0e69f56076$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $b158ee0e69f56076$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $b158ee0e69f56076$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $b158ee0e69f56076$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $b158ee0e69f56076$export$b2d8f8edec75f571);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
const $b158ee0e69f56076$export$cd75c112ac11a83b = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $b158ee0e69f56076$export$7d25d25bed94d6e2 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$fda88e8e14acb615 = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
});
const $b158ee0e69f56076$export$e890e797a25e655c = new (0, $jkqqC.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
});
const $b158ee0e69f56076$export$70208657c8d471a7 = new (0, $jkqqC.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $b158ee0e69f56076$export$b2d8f8edec75f571 = new (0, $jkqqC.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("7IK6V", function(module, exports) {
$parcel$export(module.exports, "REQUIRED", () => $e122ec4cdc64cb82$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $e122ec4cdc64cb82$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $e122ec4cdc64cb82$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $e122ec4cdc64cb82$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $e122ec4cdc64cb82$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $e122ec4cdc64cb82$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $e122ec4cdc64cb82$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $e122ec4cdc64cb82$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $e122ec4cdc64cb82$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $e122ec4cdc64cb82$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $e122ec4cdc64cb82$export$8170252f0ea43511);
$parcel$export(module.exports, "SUPPORTED_MODERNISED_PROJECT_TYPES", () => $e122ec4cdc64cb82$export$91032066c893b7fc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $e122ec4cdc64cb82$export$17bcab948893a9ba = 'worklog';
const $e122ec4cdc64cb82$export$b1c05b34d317c074 = 'REQUIRED';
const $e122ec4cdc64cb82$export$f10b32dfda12e96e = 'unknown';
const $e122ec4cdc64cb82$export$e5e4b8c32e68dd0b = 'networkError';
const $e122ec4cdc64cb82$export$2d06efb8146cd043 = 'graphQLError';
const $e122ec4cdc64cb82$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $e122ec4cdc64cb82$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $e122ec4cdc64cb82$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $e122ec4cdc64cb82$export$aac4661200ba4104 = 'worklog_startDate';
const $e122ec4cdc64cb82$export$a23c32d5cf54cba0 = 'worklog_description';
const $e122ec4cdc64cb82$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $e122ec4cdc64cb82$export$63fd567c1d0aca19 = [
    ...$e122ec4cdc64cb82$export$74ab3898ae683660,
    $e122ec4cdc64cb82$export$a1a7caa1e4a73c9f,
    $e122ec4cdc64cb82$export$cf70f9220e6a2f50,
    $e122ec4cdc64cb82$export$aac4661200ba4104,
    $e122ec4cdc64cb82$export$a23c32d5cf54cba0
];
const $e122ec4cdc64cb82$export$983715bb9b0f9b2c = {
    [$e122ec4cdc64cb82$export$17bcab948893a9ba]: $e122ec4cdc64cb82$export$63fd567c1d0aca19
};
const $e122ec4cdc64cb82$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $e122ec4cdc64cb82$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $e122ec4cdc64cb82$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $e122ec4cdc64cb82$export$8170252f0ea43511 = 'QuickCreateIssue';
const $e122ec4cdc64cb82$export$91032066c893b7fc = [
    'business',
    'software'
];

});

parcelRegister("14CWj", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $e4153b0c47dc0bdb$export$876003a5b887f37e);
/* eslint-disable jira/filename-case */ const $e4153b0c47dc0bdb$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CREATE_FORM_FIELD_FOCUS: 'CREATE_FORM_FIELD_FOCUS',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("cIX5T", function(module, exports) {
$parcel$export(module.exports, "getGICLifeCycleEvents", () => $8858188c1840e961$export$28a4bbe8d482a171);
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8858188c1840e961$export$e3ff72f196296fcc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bJ1QP = parcelRequire("bJ1QP");
const $8858188c1840e961$var$GICLifeCycleEventsService = new (0, $bJ1QP.PubSubHub)();
const $8858188c1840e961$export$28a4bbe8d482a171 = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });
const $8858188c1840e961$export$e3ff72f196296fcc = ()=>({
        ...$8858188c1840e961$var$GICLifeCycleEventsService
    });

});
parcelRegister("bJ1QP", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $e4a83e67f7372a4a$export$e3607828f8f2c01e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $e4a83e67f7372a4a$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}
$e4a83e67f7372a4a$export$e3607828f8f2c01e.displayName = "PubSubHub";

});


parcelRegister("4BBh0", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $5a3d746c864ddc29$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $5a3d746c864ddc29$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $5a3d746c864ddc29$export$59b89d5a711a4fa);
$parcel$export(module.exports, "MountEvent", () => $5a3d746c864ddc29$export$2c6963927dbc68f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // code-reaper-ignore-file -- Analytics implementations for the browser.

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");

var $io5i2 = parcelRequire("io5i2");

var $klSsw = parcelRequire("klSsw");

var $aJ81Y = parcelRequire("aJ81Y");

var $7RK6D = parcelRequire("7RK6D");

var $inMxE = parcelRequire("inMxE");


var $aZMdt = parcelRequire("aZMdt");

var $7gXAV = parcelRequire("7gXAV");

var $aqPkH = parcelRequire("aqPkH");
const $5a3d746c864ddc29$export$b6c00a2e59d74c5e = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireTrackAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$6bb7ef8f82969e8f = (event, ...rest)=>{
    if (false) return;
    return (0, $aJ81Y.fireOperationalAnalyticsDeferred)(event, ...rest);
};
const $5a3d746c864ddc29$export$59b89d5a711a4fa = (...args)=>{
    if (false) return;
    return (0, $aJ81Y.fireScreenAnalyticsDeferred)(...args);
};
const $5a3d746c864ddc29$export$2c6963927dbc68f1 = (props)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $klSsw.MountEvent), {
        onMount: props.onMount
    });
    // Note: This is a workaround to avoid type errors. The type of the props is not the same as the type of the BrowserMountEvent.
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $io5i2.MountEvent), props);
};
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = "MountEvent";
// Preserve the original displayName so snapshot tests that serialise the element tree continue to match.
$5a3d746c864ddc29$export$2c6963927dbc68f1.displayName = (0, $io5i2.MountEvent).displayName;

});
parcelRegister("io5i2", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $76dc62e6035fa733$export$2c6963927dbc68f1);
/* eslint-disable jira/filename-case */ /**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $euxye = parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");
// eslint-disable-next-line jira/react/no-class-components
class $76dc62e6035fa733$var$MountEventComponent extends (0, $euxye.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
$76dc62e6035fa733$var$MountEventComponent.displayName = "MountEventComponent";
const $76dc62e6035fa733$export$2c6963927dbc68f1 = (0, $kTviw.default)()($76dc62e6035fa733$var$MountEventComponent);

});

parcelRegister("klSsw", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $ef629069b3a57875$export$5bf35293e545f20c);
$parcel$export(module.exports, "MountEvent", () => $ef629069b3a57875$export$2c6963927dbc68f1);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

const $ef629069b3a57875$var$AnalyticsContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.children);
$ef629069b3a57875$var$AnalyticsContext.displayName = "AnalyticsContext";
const $ef629069b3a57875$export$198470770171c65 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const data = (0, $aZMdt.extractContextualData)(props);
    // @ts-expect-error - TS2741 - Property 'children' is missing in type 'Dictionary<string | string[] | { [containerName: string]: Container; } | { [key: string]: any; } | undefined>' but required in type 'AnalyticsContextData'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ef629069b3a57875$var$AnalyticsContext, {
        data: data
    }, props.children);
});
const $ef629069b3a57875$export$64eb47d7b94ba089 = ()=>null;
const $ef629069b3a57875$export$5a67e7291fd4569e = (_props)=>null;
const $ef629069b3a57875$export$5f0d7aae8dfa8b86 = (_props)=>null;
const $ef629069b3a57875$export$b71c3ada5d4ec5da = (_props)=>null;
const $ef629069b3a57875$export$2ccf161b817b43b = (_props)=>null;
const $ef629069b3a57875$export$34ac71ce24cddec2 = (_event, _type, _payload = {})=>undefined;
const $ef629069b3a57875$export$79f423cc3fd39762 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6bb7ef8f82969e8f = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$6f46fb37ad7d962b = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$59b89d5a711a4fa = (_event, _attributes)=>undefined;
const $ef629069b3a57875$export$13990ad4625571ed = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$b6c00a2e59d74c5e = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$5d00cd31b1bf8e94 = (_event, ..._rest)=>undefined;
const $ef629069b3a57875$export$ee2085e97a04e027 = (_event)=>({
        type: undefined,
        payload: {}
    });
class $ef629069b3a57875$var$UIAnalyticsEventServer {
    constructor(){
        this.payload = {};
        this.context = [];
        this.handlers = [];
        this.hasFired = false;
        // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
        this.clone = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
        // Replace with lodash/noop
        // oxlint-disable-next-line no-empty-function
        this.fire = (_channel)=>{};
        // @ts-expect-error TS2416: Property 'update' in type 'UIAnalyticsEventServer' is not assignable to the same property in base type 'UIAnalyticsEvent'. Type 'UIAnalyticsEventServer' is not assignable to type 'this'. 'UIAnalyticsEventServer' is assignable to the constraint of type 'this', but 'this' could be instantiated with a different subtype of constraint 'UIAnalyticsEventServer'.
        this.update = ()=>new $ef629069b3a57875$var$UIAnalyticsEventServer();
    }
}
$ef629069b3a57875$var$UIAnalyticsEventServer.displayName = "UIAnalyticsEventServer";
const $ef629069b3a57875$var$createAnalyticsEvent = (_payload)=>// @ts-expect-error - Type 'UIAnalyticsEventServer' is not assignable to type 'UIAnalyticsEvent'.
    new $ef629069b3a57875$var$UIAnalyticsEventServer();
const $ef629069b3a57875$export$5bf35293e545f20c = ()=>(0, $euxye.useMemo)(()=>({
            createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
        }), []);
const $ef629069b3a57875$var$withAnalyticsEvents = ()=>(WrappedComponent)=>{
        // @ts-expect-error: Argument of type '(props: Config, ref: ForwardedRef<unknown>) => Element' is not assignable to parameter of type 'ForwardRefRenderFunction<unknown, PropsWithoutRef<Config>>'.
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>// @ts-expect-error Spread types may only be created from object types.ts(2698)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, {
                ...props,
                ref: ref,
                createAnalyticsEvent: $ef629069b3a57875$var$createAnalyticsEvent
            }));
        WithAnalyticsEvents.displayName = 'WithAnalyticsEvents('.concat(WrappedComponent.displayName != null ? WrappedComponent.displayName : WrappedComponent.name || '', ')');
        // @ts-expect-error: Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'AbstractComponent<Config, any>'.
        return WithAnalyticsEvents;
    };
const $ef629069b3a57875$export$3e9ef96ba97ea9dc = (_componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
_eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>$ef629069b3a57875$var$withAnalyticsEvents()(component);
const $ef629069b3a57875$var$MountEventComponent = ({ onMount: onMount })=>{
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    (0, $euxye.useLayoutEffect)(()=>onMount(new $ef629069b3a57875$var$UIAnalyticsEventServer()), [
        onMount
    ]);
    return null;
};
$ef629069b3a57875$var$MountEventComponent.displayName = "MountEventComponent";
const $ef629069b3a57875$export$2c6963927dbc68f1 = $ef629069b3a57875$var$withAnalyticsEvents()($ef629069b3a57875$var$MountEventComponent);

});

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("7gXAV", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventToProps", () => $e8dd120ad8ac5edf$export$3e9ef96ba97ea9dc);
/* eslint-disable jira/filename-case */ 
var $kTviw = parcelRequire("kTviw");
const $e8dd120ad8ac5edf$export$871de8747c9eaa88 = (props, componentName)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $e8dd120ad8ac5edf$export$3e9ef96ba97ea9dc = (componentName, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
eventActions)=>// oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $kTviw.default)($e8dd120ad8ac5edf$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});


parcelRegister("1OTgk", function(module, exports) {
$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $cd15ee075658be2b$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $cd15ee075658be2b$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $cd15ee075658be2b$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $cd15ee075658be2b$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $cd15ee075658be2b$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $cd15ee075658be2b$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $cd15ee075658be2b$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $cd15ee075658be2b$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $cd15ee075658be2b$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $cd15ee075658be2b$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $cd15ee075658be2b$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $cd15ee075658be2b$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $cd15ee075658be2b$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_OPS_XFLOW_ONBOARDING_CREATE", () => $cd15ee075658be2b$export$3ce1e5f0e10cb8ea);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $cd15ee075658be2b$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $cd15ee075658be2b$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $cd15ee075658be2b$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $cd15ee075658be2b$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $cd15ee075658be2b$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $cd15ee075658be2b$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $cd15ee075658be2b$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $cd15ee075658be2b$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $cd15ee075658be2b$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $cd15ee075658be2b$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_BACKLOG_TRIGGER", () => $cd15ee075658be2b$export$dba86c91ec4fdbf0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $cd15ee075658be2b$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $cd15ee075658be2b$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $cd15ee075658be2b$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $cd15ee075658be2b$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $cd15ee075658be2b$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $cd15ee075658be2b$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $cd15ee075658be2b$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $cd15ee075658be2b$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $cd15ee075658be2b$export$145eb8935a34e85e);
$parcel$export(module.exports, "BOARD_CREATE", () => $cd15ee075658be2b$export$1daadfb71bec9061);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $cd15ee075658be2b$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $cd15ee075658be2b$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $cd15ee075658be2b$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $cd15ee075658be2b$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $cd15ee075658be2b$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $cd15ee075658be2b$export$7a8328e1f8bd992b);
/* eslint-disable jira/filename-case */ const $cd15ee075658be2b$export$a05673a22505d5ee = 'forge-open-issue-create';
const $cd15ee075658be2b$export$c78d329777576aa0 = 'global-create-button';
const $cd15ee075658be2b$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $cd15ee075658be2b$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $cd15ee075658be2b$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $cd15ee075658be2b$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $cd15ee075658be2b$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $cd15ee075658be2b$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $cd15ee075658be2b$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $cd15ee075658be2b$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $cd15ee075658be2b$export$9bc326812a93707 = 'jsw-security-create-issue';
const $cd15ee075658be2b$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $cd15ee075658be2b$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $cd15ee075658be2b$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $cd15ee075658be2b$export$3ce1e5f0e10cb8ea = 'jsm-ops-xflow-onboarding-create';
const $cd15ee075658be2b$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $cd15ee075658be2b$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $cd15ee075658be2b$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $cd15ee075658be2b$export$235b856f54db8916 = 'jwm-board-create-issue';
const $cd15ee075658be2b$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $cd15ee075658be2b$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $cd15ee075658be2b$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $cd15ee075658be2b$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $cd15ee075658be2b$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $cd15ee075658be2b$export$aa348159181703a0 = 'software-create-issue-dialog';
const $cd15ee075658be2b$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $cd15ee075658be2b$export$718822a309bffada = 'create-linked-issue-command-palette';
const $cd15ee075658be2b$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $cd15ee075658be2b$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $cd15ee075658be2b$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $cd15ee075658be2b$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $cd15ee075658be2b$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $cd15ee075658be2b$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $cd15ee075658be2b$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $cd15ee075658be2b$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $cd15ee075658be2b$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $cd15ee075658be2b$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $cd15ee075658be2b$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $cd15ee075658be2b$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $cd15ee075658be2b$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $cd15ee075658be2b$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $cd15ee075658be2b$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $cd15ee075658be2b$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $cd15ee075658be2b$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $cd15ee075658be2b$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $cd15ee075658be2b$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $cd15ee075658be2b$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $cd15ee075658be2b$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $cd15ee075658be2b$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $cd15ee075658be2b$export$145eb8935a34e85e = 'jwm-inline-create';
const $cd15ee075658be2b$export$1daadfb71bec9061 = 'board-create';
const $cd15ee075658be2b$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $cd15ee075658be2b$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $cd15ee075658be2b$export$220cd7b39e0b57a = 'jira-issue-comment';
const $cd15ee075658be2b$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $cd15ee075658be2b$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $cd15ee075658be2b$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $cd15ee075658be2b$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $cd15ee075658be2b$export$7a8328e1f8bd992b = [
    $cd15ee075658be2b$export$7e9cfd1f59e60910,
    $cd15ee075658be2b$export$708499dcd016e5e9,
    $cd15ee075658be2b$export$e1c8789144c4c810,
    $cd15ee075658be2b$export$c5afabb7a17e802
];

});

parcelRegister("jwOsd", function(module, exports) {
$parcel$export(module.exports, "useSitePickerContext", () => $466537c9aa0efbb5$export$f8b5aae013e4cf77);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $466537c9aa0efbb5$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $466537c9aa0efbb5$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $466537c9aa0efbb5$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $466537c9aa0efbb5$export$d4c72bab9d6cc13a,
    actions: $466537c9aa0efbb5$export$e324594224ef24da
});
const $466537c9aa0efbb5$export$f8b5aae013e4cf77 = (0, $3h1FP.createHook)($466537c9aa0efbb5$export$6f57813fe9f31bf9);

});

parcelRegister("kTMHb", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SUBMIT_BEHAVIOUR", () => $1081e3ae83892313$export$d7147f8e1d7be0e2);
/* eslint-disable jira/filename-case */ const $1081e3ae83892313$export$d7147f8e1d7be0e2 = {
    CREATE_ISSUE: 'createIssue',
    SAVE_EDITS_WITHOUT_ISSUE_CREATION: 'saveEditsWithoutIssueCreation'
};

});

parcelRegister("k2847", function(module, exports) {
$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $340b537aa60cae02$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $340b537aa60cae02$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $340b537aa60cae02$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $340b537aa60cae02$export$720579602bb055a2);
$parcel$export(module.exports, "shouldTriggerModernisedIssueCreate", () => $340b537aa60cae02$export$68a6f9b6b3dd1f1e);
$parcel$export(module.exports, "shouldForceExpandedIssueCreateModal", () => $340b537aa60cae02$export$5a45eebd3613eefc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jaJSD = parcelRequire("jaJSD");

var $6GOOT = parcelRequire("6GOOT");

var $eJ8Fl = parcelRequire("eJ8Fl");

var $VoOhq = parcelRequire("VoOhq");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $1OTgk = parcelRequire("1OTgk");
const $340b537aa60cae02$export$550b19803bc962ec = (isSubsequentLoad, isModernisedTrigger = false)=>{
    (0, $jaJSD.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $6GOOT.globalIssueCreateModalLoadSubsequent) : (0, $6GOOT.globalIssueCreateModalLoad);
    if (isSubsequentLoad) {
        if (!(isModernisedTrigger && (0, $i860n.fg)('nike_united_fix_ufo_error'))) (0, $VoOhq.default)('global-issue.create-modal-subsequent');
    } else if (!(isModernisedTrigger && (0, $i860n.fg)('nike_united_fix_ufo_error'))) (0, $VoOhq.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $eJ8Fl.startGlobalIssueCreateTTIWithAdjustments)();
};
const $340b537aa60cae02$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $340b537aa60cae02$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $340b537aa60cae02$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};
const $340b537aa60cae02$export$11ffbb568e7def20 = [
    (0, $1OTgk.GENERIC_KEYBOARD_SHORTCUT),
    (0, $1OTgk.GENERIC_GLOBAL_CREATE_BUTTON),
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK),
    (0, $1OTgk.CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW)
];
const $340b537aa60cae02$var$TRIGGER_POINTS_USING_MODERNISED_MODAL_GA = [
    (0, $1OTgk.JIRA_ISSUE_TABLE_TRIGGER),
    (0, $1OTgk.JWM_INLINE_CREATE),
    (0, $1OTgk.BOARD_CREATE),
    (0, $1OTgk.JSW_ADAPTED_GLOBAL_ISSUE_CREATE),
    (0, $1OTgk.JSW_ROADMAP_CREATE_ISSUE),
    (0, $1OTgk.JSW_CREATE_EPIC_ISSUE),
    (0, $1OTgk.CREATE_SUBTASK_NIN_TRIGGER),
    (0, $1OTgk.UC_ATLASSIAN_HOME_CREATE_ISSUE)
];
const $340b537aa60cae02$export$84ac0b8f99923a16 = [
    (0, $1OTgk.ISSUE_VIEW_CREATE_LINKED_ISSUE),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
    (0, $1OTgk.JSW_ISSUE_VIEW_CREATE_SUBTASK)
];
const $340b537aa60cae02$export$68a6f9b6b3dd1f1e = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && ($340b537aa60cae02$export$11ffbb568e7def20.includes(triggerPointKey) || $340b537aa60cae02$var$TRIGGER_POINTS_USING_MODERNISED_MODAL_GA.includes(triggerPointKey) && (0, $i860n.fg)('include_trigger_points_for_create_modernization'));
};
const $340b537aa60cae02$export$5a45eebd3613eefc = (triggerPointKey)=>{
    return (0, $2700E.expVal)('create_work_item_modernization_exp', 'isEnabled', false) && $340b537aa60cae02$export$84ac0b8f99923a16.includes(triggerPointKey);
};

});
parcelRegister("6GOOT", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $99ad8571c112a80a$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $99ad8571c112a80a$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $99ad8571c112a80a$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $99ad8571c112a80a$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $99ad8571c112a80a$export$c1592e4d8d98963e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvGCa = parcelRequire("jvGCa");
const $99ad8571c112a80a$export$5a01a7fa84b239c8 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $99ad8571c112a80a$export$c50ad3c31b6fcfc6 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $99ad8571c112a80a$export$4b2382574525bb0f = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $99ad8571c112a80a$export$7839bdaa2f6a2385 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $99ad8571c112a80a$export$c1592e4d8d98963e = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("eJ8Fl", function(module, exports) {
$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $ce28ce5101a62053$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $ce28ce5101a62053$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $ce28ce5101a62053$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $ce28ce5101a62053$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $ce28ce5101a62053$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $ce28ce5101a62053$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $ce28ce5101a62053$export$d86f4868694f2aa7);
/* eslint-disable jira/filename-case */ /**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @jira/issue-create__use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @jira/issue-create__use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $jvGCa = parcelRequire("jvGCa");
const $ce28ce5101a62053$export$9f3d6f17e1da7874 = (0, $jvGCa.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $ce28ce5101a62053$export$457c9fb71ad5b3a9 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.start();
};
const $ce28ce5101a62053$export$ef664dac649a716c = ()=>$ce28ce5101a62053$export$9f3d6f17e1da7874.mark('gic-tti');
const $ce28ce5101a62053$export$30ca4c461fab486c = (customData)=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $ce28ce5101a62053$export$27f2445288b528c = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.cancel();
};
const $ce28ce5101a62053$export$7a2709fc1e33401a = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $ce28ce5101a62053$export$cf3893335c93e33b = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $ce28ce5101a62053$export$d86f4868694f2aa7 = ()=>{
    $ce28ce5101a62053$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("iSqcu", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $9beda045c93ccce6$export$177dc7755a3f80f2);
/* eslint-disable jira/filename-case */ 
var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
var $iUbRz = parcelRequire("iUbRz");
const $9beda045c93ccce6$export$177dc7755a3f80f2 = new (0, $jkqqC.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $ipvkO.ExperienceTypes).Operation,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    until: (0, $iUbRz.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});

});

parcelRegister("9a8hO", function(module, exports) {
$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $a702af12043c7e9d$export$fc4d210bb6a1528a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $1uH7N = parcelRequire("1uH7N");

var $4Kt0R = parcelRequire("4Kt0R");
const $a702af12043c7e9d$export$fc4d210bb6a1528a = ()=>{
    (0, $1uH7N.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $4Kt0R.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


/* eslint-disable jira/filename-case */ // error types
const $2e5f0c6757041651$export$6c8cb487d6ffc522 = 'QueryError';
const $2e5f0c6757041651$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $2e5f0c6757041651$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $2e5f0c6757041651$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $2e5f0c6757041651$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $2e5f0c6757041651$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $2e5f0c6757041651$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $2e5f0c6757041651$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $2e5f0c6757041651$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $2e5f0c6757041651$export$7b20493af2e93ea0 = 'CASE_MANAGEMENT';
const $2e5f0c6757041651$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $2e5f0c6757041651$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $2e5f0c6757041651$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("hJyTq")
//# sourceMappingURL=main.f82d0360.js.map
